module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bt-1372873ed65891680a2d0a4cf3a5d35c.svg";